import CustumPopover from "components/ui/Popover";
import ButtonSearch from "components/common/filters/button-search";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";

const HeaderSearch = ({
  setInputValue,
  showPopover,
  myRef,
  value,
  handleClick,
  handleDisplaySearchResult,
  isClickedBtn,
  dataSearchWork,
  dataSearchComposer,
  handleClickWork,
  handleClickComposer,
}) => {
  const resultsListContainerRef = useRef(null);
  useEffect(() => {
    resultsListContainerRef?.current?.scrollTo({
      left: 0,
      top: 0,
      behavior: "instant",
    });
  }, [value]);

  const text =
    "You can search with the following keywords: title, composer, works or formation";

  return (
    <div className="flex flex-col pr-2 bg-cover bg-top">
      <h1 className="text-3xl md:text-4xl md:text-5xl text-center text-white font-extrabold pt-4 md:pt-10 uppercase">
        {" "}
        open <span className="text-pblue">Piano-Piano</span> Database{" "}
      </h1>
      {/* Input search */}
      <p className="text-sm md:text-lg text-center px-2 md:px-8 lg:px-16 font-light my-3 text-white">
        {text}
      </p>
      <div className="relative px-1 md:px-8 lg:px-56 2xl:px-96">
        <div id="shadowInputBottom">
          <div className="m-1 md:m-4 flex rounded bg-white w-full shadow-xl">
            <input
              onChange={setInputValue}
              onClick={handleClick}
              value={value}
              autoComplete="off"
              className="bg-white border-l-4 border-pblue rounded w-full h-16 md:h-18 pt-0 md:pt-1 pl-6 text-md font-regular border-0 shadow-none focus:shadow-none focus:outline-none"
              placeholder="Search title, composer, works or piano type"
              type="text"
            />
            <button
              onClick={handleDisplaySearchResult}
              className="px-3 md:px-6 bg-pblue uppercase border-white text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 md:h-6 w-5 md:w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </button>
          </div>
        </div>
        <div
          ref={myRef}
          className={`${
            showPopover
              ? " absolute top-14 md:top-16 md:px-8 lg:px-56 2xl:px-96 left-2 md:left-4 animate-fade-in-down w-full h-auto z-50"
              : " hidden "
          }`}
        >
          <CustumPopover>
            <div className="border-l-4 border-pblue bg-white my-4 h-auto shadow-2xl">
              <div className="flex flex-row justify-between space-x-4 p-4 px-6">
                <ButtonSearch
                  isClickedBtn={isClickedBtn === 1 ? true : null}
                  onClick={handleClickWork}
                >
                  {" "}
                  WORKS{" "}
                </ButtonSearch>
                <ButtonSearch
                  isClickedBtn={isClickedBtn === 2 ? true : null}
                  onClick={handleClickComposer}
                >
                  {" "}
                  COMPOSERS{" "}
                </ButtonSearch>
              </div>
              <div
                className="bg-white h-80 overflow-y-auto"
                ref={resultsListContainerRef}
              >
                <ul role="list" className="text-left">
                  {isClickedBtn === 1 && (
                    <>
                      {dataSearchWork.length === 0 && (
                        <div className="px-2">
                          <Skeleton
                            containerClassName="w-full"
                            height={50}
                            count={6}
                          />
                        </div>
                      )}
                      <div>
                        <p className="text-gray-600 text-sm text-left ml-6 border-b pb-2">
                          Approximately{" "}
                          <span className="font-semibold">
                            {dataSearchWork.length}
                          </span>{" "}
                          works found
                        </p>
                      </div>
                      {dataSearchWork?.map((item, index) => (
                        <li
                          onClick={handleDisplaySearchResult}
                          className="flex flex-row justify-between py-4 p-3 first:pt-0 last:pb-0 border-gray-200 border-b p-1 cursor-pointer hover:bg-gray-100"
                          key={index}
                        >
                          <div className="flex flex-row">
                            <div className="ml-3 overflow-hidden">
                              <p className="text-sm font-semibold text-gray-700 capitalize">
                                {item.title}
                              </p>
                              {item?.typeChoosen && (
                                <p className="flex flex-row mt-1 ">
                                  <img
                                    width={20}
                                    height={10}
                                    className="mr-2 block"
                                    alt="Grand piano"
                                    src="images/grand-piano.png"
                                  />
                                  <span className="text-sm text-gray-800 truncate block">
                                    {item?.typeChoosen}
                                  </span>
                                </p>
                              )}
                              {(item?.firstName || item.lastName) && (
                                <p className="text-sm text-gray-600 truncate mt-1 inline">
                                  By{" "}
                                  <span className="text-sm text-pblue italic font-semibold truncate">
                                    {item?.firstName} {item?.lastName}{" "}
                                  </span>
                                </p>
                              )}
                            </div>
                          </div>
                        </li>
                      ))}
                    </>
                  )}
                  {isClickedBtn === 2 && (
                    <>
                      {dataSearchComposer.length === 0 && (
                        <div className="px-2">
                          <Skeleton
                            containerClassName="w-full"
                            height={50}
                            count={6}
                          />
                        </div>
                      )}
                      <div>
                        <p className="text-gray-600 text-sm text-left ml-6 border-b pb-2">
                          Approximately{" "}
                          <span className="font-semibold">
                            {dataSearchComposer.length}
                          </span>{" "}
                          composers found
                        </p>
                      </div>
                      {dataSearchComposer?.map((item, index) => (
                        <li
                          onClick={handleDisplaySearchResult}
                          className="flex flex-row justify-between py-4 p-3 first:pt-0 last:pb-0 border-gray-200 border-b p-1 cursor-pointer hover:bg-gray-100"
                          key={index}
                        >
                          <div className="flex flex-row">
                            <div className="ml-3 overflow-hidden">
                              <p className="text-base font-medium text-slate-900 capitalize">
                                {item.firstName} {item.lastName}
                              </p>
                              <p className="text-sm text-slate-900 truncate mt-1">
                                {" "}
                                {!item.dateOfBirth
                                  ? ""
                                  : " Birth : " + item.dateOfBirth}{" "}
                                {!item.dateOfDeath
                                  ? ""
                                  : " - Death : " + item.dateOfDeath}{" "}
                              </p>
                            </div>
                          </div>
                        </li>
                      ))}
                    </>
                  )}
                </ul>
              </div>
            </div>
          </CustumPopover>
        </div>
      </div>
    </div>
  );
};

export default HeaderSearch;
